module.exports = __webpack_public_path__ + "img/c07_unitstartechlongship_Normal_ua.219bd7ca.webp";